export enum EventStatusEnum {
  Pending = 0,
  Confirmed = 1,
  Starting = 2,
  Started = 3,
  InProgress = 4,
  Finished = 5,
  Canceled = 6,
}
